/* The collection's ordered defer scripts have run; all inline DOM settings are parsed. */
(function () {
  'use strict';
  if (!window.Alpine || !window.Shopify || !window.Shopify.currentCollection ||
      !document.querySelector('kercambre-collection') || !customElements.get('kercambre-collection')) return;
  document.dispatchEvent(new Event('noyoco:collection-scripts-ready'));
  document.dispatchEvent(new Event('noyoco:collection-controls-ready'));
})();
